import { render, staticRenderFns } from "./SchoolCoachesImport.vue?vue&type=template&id=873df042&scoped=true&"
import script from "./SchoolCoachesImport.vue?vue&type=script&lang=ts&"
export * from "./SchoolCoachesImport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873df042",
  null
  
)

export default component.exports